import { IAddNewCourtType } from "../../Interfaces";

export function AddNewCourtType (this: any): IAddNewCourtType {
    const { name, courtTypeId } = this
    return {
        name,
        courtTypeId
    }
}
